import { useParams } from 'react-router-dom';

import { LoadingBoundary, PageContainer, PageProgress } from '../../app/components/foundation';
import { ControlPlaneSection } from '../../app/components/foundation/control-plane';

import {
  TenantWorkspaceHeader,
  DomainTable,
  TenantServicesSection,
  TenantRolesSection,
  TenantAnalyticsSection,
  TenantCommissionSection,
  TenantUsersSection,
} from './components';

import { useTenantWorkspace } from './hooks/useTenantWorkspace';
import { useTenantDomains } from './hooks/useTenantDomains';
import { useTenantServices } from './hooks/useTenantServices';
import { useTenantRoles } from './hooks/useTenantRoles';
import { useTenantAnalytics } from './hooks/useTenantAnalytics';
import { useTenantCommission } from './hooks/useTenantCommission';
import { useTenantUsers } from './hooks/useTenantUsers';

import './styles/tenants.css';

export function TenantWorkspacePage() {
  const { id } = useParams<{ id: string }>();

  const {
    tenant,
    loading,
    refetch,
  } = useTenantWorkspace(id);
  const tenantDomains = useTenantDomains(tenant?.id);
  const tenantServices = useTenantServices(tenant?.id);
  const tenantRoles = useTenantRoles(tenant?.id);
  const tenantAnalytics = useTenantAnalytics(tenant?.id);
  const tenantCommission = useTenantCommission(tenant?.id);
  const tenantUsers = useTenantUsers(tenant?.id);


  if (loading && !tenant) {
    return <LoadingBoundary loading />;
  }

  if (!tenant) {
    return (
      <div className="vania-tenants-status">
        تننت مورد نظر یافت نشد.
      </div>
    );
  }


  return (
    <>
      <PageProgress active={loading} />

      <PageContainer className="vania-tenant-profile-page">
        <PageProgress active={loading} />
        <TenantWorkspaceHeader tenant={tenant} onUpdated={refetch} />
        <ControlPlaneSection className="vania-tenant-profile-section vania-tenant-profile-section--domains">
          <DomainTable
            domains={tenantDomains.domains}
            loading={tenantDomains.loading}
            error={tenantDomains.error}
            submitting={tenantDomains.submitting}
            mutationError={tenantDomains.mutationError}
            onCreate={tenantDomains.create}
            onUpdate={tenantDomains.update}
          />
        </ControlPlaneSection>
        <ControlPlaneSection className="vania-tenant-profile-section vania-tenant-profile-section--services">
            <TenantServicesSection
              services={tenantServices.services}
              loading={tenantServices.loading}
              error={tenantServices.error}
            />
        </ControlPlaneSection>
        <ControlPlaneSection className="vania-tenant-profile-section vania-tenant-profile-section--roles">
          <TenantRolesSection
            roles={tenantRoles.roles}
            loading={tenantRoles.loading}
            error={tenantRoles.error}
          />
        </ControlPlaneSection>
        <ControlPlaneSection className="vania-tenant-profile-section vania-tenant-profile-section--analytics">
          <TenantAnalyticsSection
            analytics={tenantAnalytics.analytics}
            loading={tenantAnalytics.loading}
            error={tenantAnalytics.error}
          />
        </ControlPlaneSection>
        <ControlPlaneSection className="vania-tenant-profile-section vania-tenant-profile-section--users">
          <TenantUsersSection
            users={tenantUsers.users}
            loading={tenantUsers.loading}
            error={tenantUsers.error}
          />
        </ControlPlaneSection>
        <ControlPlaneSection className="vania-tenant-profile-section vania-tenant-profile-section--commission">
          <TenantCommissionSection
            commissions={tenantCommission.commissions}
            summary={tenantCommission.summary}
            loading={tenantCommission.loading}
            error={tenantCommission.error}
          />
        </ControlPlaneSection>
      </PageContainer>
    </>
  );
}
